var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"coupon-field-text"},[_vm._v(" "+_vm._s(_vm.generalConditions)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }